import React, { useEffect, useState } from "react";
import { Modal } from "@mui/material";
import { toast } from "react-toastify";
import { axiosGetApi, axiosPostApi } from "../../../helpers/interceptorServices";
import { apiList } from "../../../helpers/apiList";
import CustomAlert from "../../../helpers/CustomAlert";
import CrossIcon from "../../../assets/Icons/cross_svg.svg";
import LeftCircle from "../../../assets/Icons/Left circle B.png";
import RightCircle from "../../../assets/Icons/Right circle A.png";

export default function MapTrackIdModal({
  open,
  onClose,
  hubLoading,
  columnData,
  callApi
}) {
  const loggedInUserName = sessionStorage.getItem("username");

  const [data, setData] = useState([]);
  const [deliveryType, setDeliveryType] = useState("");
  const [waybill, setWaybill] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({
    deliveryType: "",
    waybill: "",
  });

  useEffect(() => {
    if (open) {
      setDeliveryType("");
      setWaybill("");
    }
  }, [open]);

  // ✅ Validation + Submit
  const handleSubmit = () => {
  let newErrors = {
    deliveryType: "",
    waybill: "",
  };

  if (!deliveryType) {
    newErrors.deliveryType = "Please select delivery type";
  }

  if (!waybill) {
    newErrors.waybill = "Please enter waybill number";
  } else {
    const waybillRegex = /^[0-9]{10,15}$/;
    if (!waybillRegex.test(waybill)) {
      newErrors.waybill = "Waybill must be 10–15 digits";
    }
  }

  setErrors(newErrors);

  // ❌ Stop submit if any error exists
  if (newErrors.deliveryType || newErrors.waybill) return;

  handelUpdateWayBill();
};

  const handelUpdateWayBill = async () => {
    setLoading(true);

    try {
      const payload = {
        username: loggedInUserName,
         orderId: columnData?.id,
         waybill: waybill,
         orderSubmitSource: deliveryType,
      };

      const response = await axiosPostApi(
        `${apiList.UPDATE_WAY_BILLNUMBER}`,
        payload
      );
      const data = response?.data?.data;
      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        CustomAlert({
          title: "Success",
          text: response?.data?.message,
          icon: "success",
          confirmButtonText: "Okay",
        });
        setLoading(false);
        onClose();
        callApi()
      }
    } catch (error) {
      setLoading(false);
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white px-6 py-3 rounded-xl shadow-lg w-[500px]">
        {/* <h3 className="text-lg font-semibold text-center mb-5 text-gray-800">
          Map Id
        </h3> */}
        <div className="rounded-[23px]">
             <img
                src={LeftCircle}
                alt="leftImg"
                className="absolute left-0 bottom-0 w-[110px] h-[105px]"
              />
              <img
                src={RightCircle}
                alt="leftImg"
                className="absolute right-0 top-0 w-[110px] h-[105px]"
              />
          <div className="modal-header justify-between flex pb-2">
            <div className="flex items-center gap-4">
              {/* <img src={AddIcon} alt="icon" className="w-10 h-10" /> */}
              <h5 className="modal-title main-title m-0 font-medium">
                Map WayBill Number
              </h5>
            </div>
            <img
              src={CrossIcon}
              alt="close"
              className="w-[30px] h-[30px] cursor-pointer z-10"
              onClick={onClose}
            />
          </div>
        </div>

        <div style={{display:"flex", gap: "20px"}}>
            {/* Delivery Type */}
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-medium mb-2">
            Delivery Type <span className="text-red-500">*</span>
          </label>
          <select
            value={deliveryType}
            onChange={(e) => setDeliveryType(e.target.value)}
            className="
             w-full 
             border border-gray-300 
             rounded-lg 
             px-3 py-2 
             text-gray-700
             focus:outline-none
             focus:ring-2 
             focus:ring-orange-400
            "
          >
            <option value="">-- Select Type --</option>
            <option value="TRACKON">Trackon</option>
            <option value="DIRECT_DELHIVERY">Direct Delhivery</option>
            <option value="SHREE_TIRUPATI">Shree Tirupati</option>
          </select>
          {errors.deliveryType && (
             <p className="text-red-500 text-xs mt-1">
               {errors.deliveryType}
             </p>
           )}
            </div>
    
            {/* Waybill */}
            <div className="mb-6">
          <label className="block text-gray-700 text-sm font-medium mb-2">
            Waybill Number <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            value={waybill}
            onChange={(e) =>
              setWaybill(e.target.value.replace(/\D/g, ""))
            }
            placeholder="Waybill Number"
            maxLength={15}
            className="
             w-full 
             border border-gray-300 
             rounded-lg 
             px-3 py-2 
             text-gray-700
             focus:outline-none
             focus:ring-2 
             focus:ring-orange-400
            "
          />
          {errors.waybill && (
             <p className="text-red-500 text-xs mt-1">
               {errors.waybill}
             </p>
           )}
        </div>

        </div>

        {/* Footer Buttons */}
        <div className="flex justify-center gap-4 border-t pt-4">
          <button
            type="button"
            onClick={onClose}
            className="btn btn-back w-[130px] !rounded-lg bg-gray-200 text-gray-700 hover:bg-gray-300"
          >
            Cancel
          </button>

          <button
            type="button"
            onClick={handleSubmit}
            disabled={hubLoading}
            className="btn btn-submit w-[130px] !rounded-lg"
          >
            {hubLoading ? "Submitting..." : "Submit"}
          </button>
        </div>
      </div>
    </Modal>
  );
}
